module.exports = __webpack_public_path__ + "media/images/riachuelo-be8a568c7405faee11d43a6e50911195.png";